/**
 * 根组件：主题 + CssBaseline + BrowserRouter + 路由表。
 *
 * 应用启动时同步从 localStorage 恢复会话（restoreSession），避免刷新后跳登录。
 *
 * @module App
 */
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';

import AppRouter from '@/router';
import { useAuthStore } from '@/store/authStore';

// 启动即恢复会话（同步读取 localStorage）。
useAuthStore.getState().restoreSession();

/** 全局主题：主色 indigo，圆角卡片化风格。 */
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#4f46e5' },
    secondary: { main: '#0ea5e9' },
    background: { default: '#f5f6f8' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Microsoft YaHei", sans-serif',
  },
});

/**
 * 根组件。
 *
 * @returns JSX 元素。
 */
export default function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ThemeProvider>
  );
}
